const pic1 = require("./images/pic1.jpeg");
const pic2 = require("./images/pic2.jpeg");
const pic3 = require("./images/pic3.jpeg");


export { pic1, pic2, pic3 };
